<template>
  <div class="body_show" v-if="body_show">
    <div class="men_detail">
      <img src="@a/cp55_top.png" alt="" />
    </div>
    <div class="men_main">
      <h2 class="clearfix"><span class="pull-left"></span><span class="pull-right"></span></h2>
      <h3>测评简介<span></span></h3>
      <p>所谓可迁移能力，指的就是从一份工作转移到另一份工作，无论岗位行业如何变化，也依然能够无障碍迁移的能力。</p>
      <p>可迁移能力，是一个人最有效的职场优势。</p>
      <ul>
        <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">
            如何了解自己的可迁移能力？
          </div>
        </li>
        <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">
            自己拥有哪些突出的优势？
          </div>
        </li>
         <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">
            又有哪些方面相对不足？ 
          </div>
        </li>
      </ul>
      <p class="last_child">新精英测评研发团队基于数百份胜任力模型的分析，搭建出职场可迁移能力模型，包括思维能力、人际能力、任务管理和团队管理四个维度12项能力。</p>
      <h3>您会获得什么？<span></span></h3>
      <ul>
        <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">
            1、明确自己的能力优劣势在哪里
          </div>
        </li>
        <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">
            2、获取自我提升的方法
          </div>
        </li>
         <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">
            3、获得他人对你的能力的反馈，梳理出共识和盲点
          </div>
        </li>
      </ul>
      <h3>适合人群<span></span></h3>
      <ul>
        <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">想要了解自己可迁移能力优劣势的职场人士</div>
        </li>
        <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">即将毕业的大学生</div>
        </li>
      </ul>
      <h3>报告样例<span></span></h3>
      <!--  -->
      <ul>
        <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">
            自评部分
          </div>
        </li>
      </ul>
      <ul>
        <li class="cp47-li clearfix">
          <img class="cp47-img" src="@a/ceping-mp/cp-mp-r1.jpg" alt="" >
          <img class="cp47-img" src="@a/ceping-mp/cp-mp-r2.jpg" alt="" >
        </li>
      </ul>
      <ul>
        <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">
            他评部分
          </div>
        </li>
      </ul>
      <ul>
        <li class="cp47-li clearfix">
          <img class="cp47-img" src="@a/ceping-mp/cp-mp-r1-1.jpg" alt="" >
          <img class="cp47-img" src="@a/ceping-mp/cp-mp-r2-1.jpg" alt="" >
          <img class="cp47-img" src="@a/ceping-mp/cp-mp-r3-1.jpg" alt="" >
          <img class="cp47-img" src="@a/ceping-mp/cp-mp-r4-1.jpg" alt="" >
        </li>
      </ul>
      <h3>测评须知<span></span></h3>
      <ul>
        <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">答案没有好坏、对错之分，不必仔细推敲；请结合自己的实际情况，相信自己的第一感觉作答。</div>
        </li>
      </ul>
      <h2 class="clearfix h_v"><span class="pull-left"></span><span class="pull-right"></span></h2>
    </div>
    <div class="men_foots">
      <router-link to="/my_work_ability_details_p1" v-if="data.report">查看报告</router-link>
      <router-link to="/measurement_public_p1" v-else>点击进入测评</router-link>
    </div>
  </div>
</template>
<script>
import {
  ceping52_detail
} from "@/api/measurement";
import {
  queryString
} from "@/utils/tools";
import {
  shareCon
} from "@/utils/wxconfig";
let img = require('../../../assets/cep_ewm.png');
export default {
  data() {
      return {
        headImg: "",
        picture: "",
        data: {},
        body_show: false,
        subscribe: false,
        cids: "",
        card_show: false,
        imgLink: img,
        link: "",
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: ""
        },
      }
    },
    methods: {
      pullData() {
        let cid = this.$route.query.cid;
        ceping52_detail()
          .then((data) => {
            this.body_show = true;
            document.title = data.headtitle;
            this.data = data;
            this.type_obj.evaluation_id = data.cid;          
            this.type_obj.evaluation_name = data.headtitle;          
            this.type_obj.evaluation_user_id = data.uid;          
            this.type_obj.nickname = data.nickname;          
            this.type_obj.path = this.$route.path;       
            shareCon("measurement_new", this, this.type_obj);

            // 神策统计--打开页面时触发
            sensors.track('evaluationPage', {
              evaluation_id: this.$route.query.cid,
              evaluation_name: this.data.headtitle,
              evaluation_url: window.location.href,
              evaluation_page_title: this.data.headtitle,
              share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
              channel_name: this.$route.query.channel ? this.$route.query.channel : ""
            })
          })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.body_show {
  padding-bottom: 198px;
  background-color: #fde784;
}

.men_detail {
  width: 100%;
  text-align: center;
  img {
    width: 100%;
  }
}

.men_foots {
  width: 100%;
  height: 98px;
  line-height: 98px;
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -375px;
  max-width: 750px;
  text-align: center;
  background: #844955;
  z-index: 2;
  color: #fff;
  font-size: 34px;
  a {
    display: block;
    width: 100%;
    height: 100%;
    color: #fff
  }
}

.men_main {
  width: 690px;
  height: auto;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  padding: 30px;
  margin: 0 auto;
  margin-top: -132px;
  position: relative;
  h2 {
    width: 100%;
    span {
      display: inline-block;
      width: 20px;
      height: 20px;
      background: rgba(132, 73, 85, 1);
      border-radius: 10px;
    }
  }
  .h_v {
    margin-top: 80px;
  }
  h3 {
    font-size: 34px;
    color: #333;
    position: relative;
    padding-bottom: 10px;
    margin-top: 50px;
    text-align: center;
    span {
      width: 68px;
      height: 4px;
      background: rgba(249, 207, 89, 1);
      display: inline-block;
      position: absolute;
      left: 50%;
      margin-left: -34px;
      bottom: 0
    }
  }
  p {
    margin-top: 50px;
    text-align: justify;
    line-height: 40px;
    color: #333;
    font-size: 26px;
  }
  p.ti{
    text-indent: 2em;
  }
  p.last_child {
    padding-bottom: 80px;
    border-bottom: 2px dashed #F9CF59;
  }
  ul {
    padding-bottom: 80px;
    border-bottom: 2px dashed #F9CF59;
    li {
      margin-top: 50px;
      span {
        display: inline-block;
        margin-right: 24px;
        background-color: #F9CF59;
        width: 12px;
        height: 12px;
        margin-top: 10px;
        border-radius: 50%;
      }
      .lr {
        width: 590px;
        color: #2C1B23;
        font-size: 26px;
        line-height: 40px;
      }
    }
  }
}
.cp47-li{
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  .cp47-img{
    width: 310px;
    height: 450px;
    &:nth-child(odd){
      margin-right: auto;
    }
  }
}

</style>
